import { render, staticRenderFns } from "./RequestEditTabGeneralInformation.vue?vue&type=template&id=010cef1a&scoped=true&"
import script from "./RequestEditTabGeneralInformation.vue?vue&type=script&lang=js&"
export * from "./RequestEditTabGeneralInformation.vue?vue&type=script&lang=js&"
import style0 from "./RequestEditTabGeneralInformation.vue?vue&type=style&index=0&id=010cef1a&lang=scss&scoped=true&"
import style1 from "./RequestEditTabGeneralInformation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010cef1a",
  null
  
)

export default component.exports